import {
  faCaretDown,
  faCaretUp,
  faCheckCircle,
  faTimesCircle,
} from '@fortawesome/pro-solid-svg-icons';
import { Button } from 'src/components/Button';
import { Icon } from 'src/components/Icon';
import { Visit } from 'src/models/visit/_types';

import {
  getVisitStatusButtonCompactSx,
  getVisitStatusButtonLabel,
  getVisitStatusButtonStyle,
  getVisitStatusButtonVariant,
} from './visitStatusButtonConfig';

interface VisitStatusTriggerButtonProps {
  visit: Visit;
  open: boolean;
  onClick: () => void;
  compact?: boolean;
}

export const VisitStatusTriggerButton = ({
  visit,
  open,
  onClick,
  compact = false,
}: VisitStatusTriggerButtonProps) => {
  const style = getVisitStatusButtonStyle(visit);
  const label = getVisitStatusButtonLabel(visit);
  const variant = getVisitStatusButtonVariant(style, compact);
  const compactSx = getVisitStatusButtonCompactSx(compact);
  const endIcon = (
    <Icon
      sx={{ fontSize: '0.75rem !important' }}
      icon={open ? faCaretUp : faCaretDown}
    />
  );

  if (style.icon) {
    return (
      <Button
        size="small"
        color={style.color}
        variant={variant}
        onClick={onClick}
        sx={compact ? { ...compactSx, pl: 1 } : { pl: 1 }}
        endIcon={endIcon}
        startIcon={
          compact ? undefined : (
            <Icon
              sx={{ fontSize: '1.25rem !important' }}
              icon={style.icon === 'times' ? faTimesCircle : faCheckCircle}
            />
          )
        }
      >
        {label}
      </Button>
    );
  }

  return (
    <Button
      size="small"
      color={style.color}
      variant={variant}
      onClick={onClick}
      sx={compactSx}
      endIcon={endIcon}
    >
      {label}
    </Button>
  );
};
